import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { FavoriteItems } from '../models';
import { ChooseLocation } from '@symphony-solo/domain/choose-location/src';
import { Voucher } from '@symphony-solo/domain/voucher/src';
import { Purses } from '@symphony-solo/domain/purses/src';
export class FavouriteItemState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public favoriteItems: FavoriteItems
  public limitsReached: {
    [key: string]: boolean; // key is itemType, value is whether the limit is reached
  };
  public accountID: number;
  public locations: ChooseLocation[];
  public vouchers: Voucher[];
  public wallets: Purses[];

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.locations = [];
    this.favoriteItems = {
      location: [],
      voucher: [],
      wallet: [],
      clickAndCollect: [],
      accountID: null
    },
    this.limitsReached = {
      location: false,
      voucher: false,
      wallet: false,
      clickAndCollect: false,
    };
    this.accountID = null;
  }
}
